import {Component, EventEmitter, Output, input, linkedSignal, ChangeDetectionStrategy} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {FormatKeyPipe} from '../../../../pipes/format-key.pipe';
import {WaCardDirective, WaSliderDirective} from "angular-awesome";

@Component({
    selector: 'app-slider',
    templateUrl: './slider.component.html',
    styleUrls: ['./slider.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, FormatKeyPipe, WaCardDirective, WaSliderDirective]
})
export class SliderComponent {

  readonly name = input.required<string>();
  readonly value = input.required<number>();
  readonly description = input<string>("");

  @Output() valueChangeEvent = new EventEmitter<number>();

  /**
   * linkedSignal: initializes from the `value` input.
   * When the parent recreates this component (via sliderVersion in the track expression),
   * the component starts fresh with the correct value from the loaded parameter set.
   * User slider interactions override this value via .set().
   */
  readonly sliderValue = linkedSignal(() => this.value());

  updateValue(): void {
    this.valueChangeEvent.emit(this.sliderValue());
  }
}
